import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
@Component({
  selector: 'app-edit-ticket',
  templateUrl: './edit-ticket.component.html',
  styleUrls: ['./edit-ticket.component.scss']
})
export class EditTicketComponent implements OnInit {
  id ;
  formdata;
  constructor(private route: ActivatedRoute, 
    private formBuilder: FormBuilder, private config: ApiConfiguration, 
    private http : ApiService, private router: Router, private toast: ToastClientService) { }
  orderForm: FormGroup = new FormGroup({
    items: new FormArray([])
  });
  items: FormArray = this.orderForm.get('items') as FormArray;
  ngOnInit() {
    this.route.params.subscribe((data:any)=>{
      console.log(data.id);
      this.id = data.id;
      this.http.get(this.config.baseUrl2 + this.config.ticketById+"ticket_id="+data.id)
      .subscribe((data:any)=>{
          this.formdata = data.data.ticket_type_data;
          if(this.formdata.length > 0){
            this.formdata.forEach(element => {
              this.items.push(this.createItem(element.ticket_field_name, element.ticket_field_type, element.ticket_field_order))
            });
          }else{
            this.items.push(this.createItem());
          }
          
      })


    })
    
  }

  createItem(name = "", boxtype="0", order="0"): FormGroup {
    return this.formBuilder.group({
      ticket_field_name: name,
      ticket_field_type: boxtype,
      ticket_field_order: order
    });
  }

  addItem(): void {
    this.items.push(this.createItem());
  }

  deleteItem(): void {
    if(this.items.length >  1){
      this.items.removeAt(this.items.length-1)
    }
    
  }

  submit(){
    let payload = {
      "ticket_type_id": this.id,
        "ticket_type_data": this.orderForm.value.items
    }

    this.http.post(this.config.baseUrl2+ this.config.createTicketData, payload)
    .subscribe((data:any)=>{
      this.toast.Success("Updated Successfully")
      this.router.navigateByUrl("/hubAdmin/ticketing");
      
    }, (err)=>{
      this.toast.Error(err.message)
    })
  }

}
